<!-- Webhook Configuration -->
@if (config) {
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <mat-icon>webhook</mat-icon>
        {{ title }} webhook
      </mat-card-title>
      <mat-card-subtitle>{{ descriptions }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content fxLayout="column" fxLayoutGap="16px">
      <div>
        <div><strong>URL:</strong></div>
        <div class="value-text">{{ config.url || 'Not configured' }}</div>
      </div>
      @if (config.auth) {
        <div>
          <div><strong>Authentication:</strong></div>
          <div class="value-text">Configured</div>
        </div>
      }
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>tune</mat-icon>
            Webhook Details
          </mat-panel-title>
        </mat-expansion-panel-header>
        <pre class="config-value">{{ formatJsonValue(config) }}</pre>
      </mat-expansion-panel>
    </mat-card-content>
  </mat-card>
}
